import i18n from '@/i18n'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import List from './list.vue'
import Layout from '../layout.vue'
import UpdateTask from './updateTaskHistory.vue'
import { i18nPrefix } from '@/components/openQuestion/common'

const basePath = '/v-admin/open-question/template/management'

const routes = [
  {
    name: 'jobQuestionTemplateManagementList',
    path: `${basePath}/list`,
    component: List,
    meta: {
      breadcrumb: { hidden: true },
      titleI18nKey: `${i18nPrefix}.template.title`
    }
  },
  {
    name: 'jobQuestionTemplateUpdateTaskHistory',
    path: `${basePath}/task/list`,
    component: UpdateTask,
    meta: {
      titleI18nKey: `${i18nPrefix}.template.taskTitle`
    }
  }
]

export default {
  name: 'jobQuestionTemplateManagement',
  path: `${basePath}/list`,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    permission: 'PERM_JOB_QUESTION_TEMPLATE',
    menu: {
      get label () {
        return i18n.t(`${i18nPrefix}.template.menu`)
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.RECRUIT
    }
  },
  children: routes
}
